const ArrowRightIcon = (props: JSX.IntrinsicElements["svg"]) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} viewBox="0 0 17 16" fill="none">
      <path d="M6.5 4L10.5 8L6.5 12" stroke="currentColor" strokeOpacity="0.6" />
    </svg>
  );
};

export default ArrowRightIcon;
